import { z } from 'zod';

export type StaticMessage = z.infer<typeof staticMessageSchema>;
export const staticMessageSchema = z.object({
  message: z.string(),
});
